import { SORT_DIRECTION_ASC, sortReports } from './helpers/sort'

export default {
  REPORTS: (state) => ({ sortBy = '', sortDirection = SORT_DIRECTION_ASC } = {}) => {
    let reports = state.reports
    if (sortBy) {
      reports = sortReports({ reports, sortBy, sortDirection })
    }
    return reports
  },
  REPORT: (state) => ({ reportId }) => {
    return state.reports.find(report => report.id === reportId)
  }
}
